import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Navigation from '../../services/Navigation';
import { stripeLinkWithReferrer } from '../../utils/purchaseReferrer';
import Constants from '../../submodules/logictry_config/constants';

const ButtonWrapper = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  * {
    font-size: ${Constants.NormalFontSize};
  }
  ${Constants.MediaMobile} {
    font-size: ${Constants.SemiSmallFontSize};
  }
  > button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1.25;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
  }
`;
const Unfilled = styled(ButtonWrapper)`
  > button {
    box-shadow: unset;
    color: ${Constants.DarkTextColor};
    ${Constants.MediaTabletAndDesktop} {
      &:hover {
        background-color: unset;
        color: ${Constants.PrimaryColor};
      }
    }
  }

  ${Constants.MediaMobile} {
    * {
      min-width: 0px !Important;
    }
  }
`;
const Filled = styled(ButtonWrapper)`
  > button {
    background-color: ${Constants.PrimaryColor};
    span {
      color: ${Constants.White};
    }
    * {
      color: ${Constants.White};
    }

    &:hover, &:focus, &:active {
      * {
        color: ${Constants.White};
      }
    }
  }

  ${Constants.MediaMobile} {
    * {
      min-width: 0px !Important;
    }
  }
`;

function Button(props) {
  const absoluteUrl = props.absoluteUrl ? stripeLinkWithReferrer(props.absoluteUrl) : props.absoluteUrl;
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (props.url) Navigation.push(props.url);
    if (absoluteUrl) Navigation.site(absoluteUrl);
    if (props.onClick) props.onClick();
  };

  const button = (
    <button
      type="button"
      style={{ textTransform: props.upperCase ? 'uppercase' : 'none' }}
      onClick={onClick}
      ref={props.buttonRef}
      tabIndex={(Object.hasOwnProperty.call(props, 'tabIndex') ? props.tabIndex : -1)}
    >
      {props.children}
    </button>
  );

  if (props.filledColor) {
    return (<Filled
      tabIndex={-1}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
      href={props.url ? `${window.location.origin}${props.url}` : absoluteUrl}
    >{button}</Filled>);
  }
  return (<Unfilled
    tabIndex={-1}
    onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
    href={props.url ? `${window.location.origin}${props.url}` : absoluteUrl}
  >{button}</Unfilled>);
}

Button.propTypes = {
  children: PropTypes.any,
  url: PropTypes.string,
  absoluteUrl: PropTypes.string,
  onClick: PropTypes.func,
  buttonRef: PropTypes.func,
  filledColor: PropTypes.bool,
  tabIndex: PropTypes.number,
  upperCase: PropTypes.bool,
};

export default Button;
